import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'GradeDialog',
  props: {
    userInfo: {
      type: Object,
      default: function _default() {}
    },
    areaGradeInfo: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      activeIndex: 0,
      grade: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.grade = this.userInfo.grade;

    if (this.areaGradeInfo.eduInfo[1].gradeInfo.filter(function (i) {
      return i.id === _this.grade;
    }).length) {
      this.activeIndex = 1;
    }
  },
  methods: {
    // 切换初中高中
    changeActive: function changeActive(i) {
      this.activeIndex = i;
    },
    // 改变年级ID
    changeGradeId: function changeGradeId(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.grade = id;

                _this2.saveGrade();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 保存
    saveGrade: function saveGrade() {
      this.$attrs.close({
        edu: this.areaGradeInfo.eduInfo[this.activeIndex].id,
        grade: this.grade
      });
    }
  }
};